
//User 
export const SET_USER = "SET_USER";
export const SET_AUTHENTICATED = "SET_AUTHENTICATED"
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED"
export const SET_CALCULATOR = "SET_CALCULATOR";
export const SET_STATUS = "SET_STATUS";
export const SET_CRTERM = "SET_CRTERM";

//Data 
export const SET_CASH_TRANSACTIONS = "SET_CASH_TRANSACTIONS";
export const SET_BACKBTN = "SET_BACKBTN";






export const SET_QUESTIONS = "SET_QUESTIONS";


//UI
export const SET_LOADING = "SET_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const SET_ERROR = "SET_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
